import { c as _c } from "react/compiler-runtime";
import useActivityBookingCalculatedPrice from '@/contexts/activityBookingContext/hooks/useActivityBookingCalculatedPrice';
import useActivityBookingFilters from '@/contexts/activityBookingContext/hooks/useActivityBookingFilters';
import useActivityBookingFiltersStates from '@/contexts/activityBookingContext/hooks/useActivityBookingFiltersStates';
import useActivityBookingInitialization from '@/contexts/activityBookingContext/hooks/useActivityBookingInitialization';
import { useEffect, useState } from 'react';
import TunnelTemplate from '../../components/TunnelTemplate';
import CancellationInfo from '../components/CancellationInfo';
import ActivityBookingForm from './ActivityBookingForm';
import ActivityBookingSticky from './ActivityBookingSticky';
const ActivityBooking = t0 => {
    const $ = _c(21);
    const { experience } = t0;
    const filters = useActivityBookingFilters();
    const { completion } = useActivityBookingFiltersStates();
    const { handleInitializeFilters, initializingFilters } = useActivityBookingInitialization();
    const { calculatedPrice } = useActivityBookingCalculatedPrice();
    const loading = initializingFilters;
    const [filtersInitialized, setFiltersInitialized] = useState(false);
    let t1;
    if ($[0] !== experience.identifier || $[1] !== experience.stock || $[2] !== filtersInitialized || $[3] !== handleInitializeFilters) {
        t1 = () => {
            if (!filtersInitialized) {
                handleInitializeFilters(experience.identifier, experience.stock);
                setFiltersInitialized(true);
            }
        };
        $[0] = experience.identifier;
        $[1] = experience.stock;
        $[2] = filtersInitialized;
        $[3] = handleInitializeFilters;
        $[4] = t1;
    }
    else {
        t1 = $[4];
    }
    let t2;
    if ($[5] !== experience || $[6] !== filtersInitialized || $[7] !== handleInitializeFilters) {
        t2 = [handleInitializeFilters, filtersInitialized, experience];
        $[5] = experience;
        $[6] = filtersInitialized;
        $[7] = handleInitializeFilters;
        $[8] = t2;
    }
    else {
        t2 = $[8];
    }
    useEffect(t1, t2);
    let t3;
    if ($[9] !== experience) {
        t3 = <ActivityBookingSticky experience={experience}/>;
        $[9] = experience;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    let t4;
    if ($[11] !== calculatedPrice || $[12] !== completion || $[13] !== experience.cancellation || $[14] !== filters) {
        t4 = <CancellationInfo loading={false} filters={filters} cancellation={experience.cancellation} completion={completion} calculatedPrice={calculatedPrice}/>;
        $[11] = calculatedPrice;
        $[12] = completion;
        $[13] = experience.cancellation;
        $[14] = filters;
        $[15] = t4;
    }
    else {
        t4 = $[15];
    }
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <ActivityBookingForm />;
        $[16] = t5;
    }
    else {
        t5 = $[16];
    }
    let t6;
    if ($[17] !== loading || $[18] !== t3 || $[19] !== t4) {
        t6 = <><TunnelTemplate loading={loading} stickyContent={t3} className="!mb-0">{t4}{t5}</TunnelTemplate></>;
        $[17] = loading;
        $[18] = t3;
        $[19] = t4;
        $[20] = t6;
    }
    else {
        t6 = $[20];
    }
    return t6;
};
export default ActivityBooking;
